export default "__VITE_ASSET__832fbc3f__"